/* Portfolio*/
import chatGpt3 from '../img/chatGpt3.png';
import restaurant from '../img/restaurant.png';
import youTubeClone from '../img/youtube-clone.png';
/*testimonial  */
import profilePic1 from '../img/profile1.jpg';
import profilePic2 from '../img/profile2.jpg';
import profilePic3 from '../img/profile3.jpg';
import profilePic4 from '../img/profile4.jpg';

export const navList = [
  {
    id: 1,
    displayName: 'Home',
    link: 'Navbar',
  },
  {
    id: 2,
    displayName: ' Services',
    link: 'services',
  },
  {
    id: 3,
    displayName: 'Experience',
    link: 'works',
  },
  {
    id: 4,
    displayName: 'Portfolio',
    link: 'portfolio',
  },
  // {
  //   id: 5,
  //   displayName: 'Testimonial',
  //   link: 'testimonial',
  // },
];

// transition
export const transition = {
  duration: 1,
  type: 'string',
};

//experience
export const experienceData = [
  {
    id: 1,
    years: '2+',
    textOne: 'Years',
    textTwo: 'experience',
  },
  {
    id: 2,
    years: '10+',
    textOne: 'Completed',
    textTwo: 'projects',
  },
  {
    id: 3,
    years: '2+',
    textOne: 'Companies',
    textTwo: 'work',
  },
];

export const portfolioSlidesData = [
  {
    id: 1,
    image: youTubeClone,
    to: 'https://youtube-rd.netlify.app/',
  },
  {
    id: 2,
    image: chatGpt3,
    to: 'https://mygptdemo-rd.netlify.app/',
  },
  {
    id: 3,
    image: restaurant,
    to: 'https://restaurant-rd.netlify.app/',
  },
];

export const clientsData = [
  {
    img: profilePic1,
    review:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex officiis molestiae quod tempora laudantium, cumque error a nisi placeat quae exercitationem, maiores reiciendis! Eaque dicta minima, iure maiores dolorum sed.',
  },
  {
    img: profilePic2,
    review:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex officiis molestiae quod tempora laudantium, cumque error a nisi placeat quae exercitationem, maiores reiciendis! Eaque dicta minima, iure maiores dolorum sed.',
  },
  {
    img: profilePic3,
    review:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex officiis molestiae quod tempora laudantium, cumque error a nisi placeat quae exercitationem, maiores reiciendis! Eaque dicta minima, iure maiores dolorum sed.',
  },
  {
    img: profilePic4,
    review:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex officiis molestiae quod tempora laudantium, cumque error a nisi placeat quae exercitationem, maiores reiciendis! Eaque dicta minima, iure maiores dolorum sed.',
  },
];
